import React, { useEffect } from 'react';
import styles from './NotificationComponent.module.css'; // Optional: Add styles here

const NotificationComponent = ({ message, setShowNotification }) => {
  useEffect(() => {
    // Hide the notification after 3 seconds
    const timer = setTimeout(() => {
      setShowNotification(false);
    }, 3000);

    return () => clearTimeout(timer); // Cleanup timeout on unmount
  }, [setShowNotification]);

  return (
    <div className={styles['NotificationComponent']}>
      {message}
    </div>
  );
};

export default NotificationComponent;
